export const buildAddressObject = (data) => {
    if (!data)
        return null;
    const { geometry, address_components, formatted_address } = data;
    const lat = geometry.location.lat.toString();
    const lng = geometry.location.lng.toString();
    const obj = {
        fullAddress: formatted_address,
        coordinates: {
            lat: lat.toString(),
            lng: lng.toString(),
        },
        street_number: address_components.find((c) => c.types.includes("street_number"))?.long_name,
        street_name: address_components.find((c) => c.types.includes("route"))?.long_name,
        suburb: address_components.find((c) => c.types.includes("sublocality"))?.long_name,
        city: address_components.find((c) => c.types.includes("locality"))?.long_name,
        province: address_components.find((c) => c.types.includes("administrative_area_level_1"))?.long_name,
        country: address_components.find((c) => c.types.includes("country"))?.long_name,
        postal_code: address_components.find((c) => c.types.includes("postal_code"))?.long_name,
        country_code: address_components.find((c) => c.types.includes("country"))?.short_name,
    };
    return obj;
};
